import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '../icon/icon.module';

import { CheckboxGridHeaderModule } from './checkbox-grid-header/checkbox-grid-header.module';
import { CheckboxRowWrapperComponent } from './checkbox-row/checkbox-row-wrapper/checkbox-row-wrapper.component';
import { CheckboxRowComponent } from './checkbox-row/checkbox-row.component';
import { CheckboxCellComponent } from './checkbox-cell/checkbox-cell.component';
import { CheckboxGridComponent } from './checkbox-grid.component';
import { CheckboxGridService } from './checkbox-grid.service';

@NgModule({
  declarations: [
    CheckboxGridComponent,
    CheckboxRowComponent,
    CheckboxCellComponent,
    CheckboxRowWrapperComponent,
  ],
  imports: [CommonModule, CheckboxGridHeaderModule, IconModule],
  exports: [
    CheckboxGridComponent,
    CheckboxCellComponent,
    CheckboxRowComponent,
    CheckboxRowWrapperComponent,
  ],
  providers: [CheckboxGridService],
})
export class CheckboxGridModule {}
